<section class="app-pil-sli">
  <div class="app-pil-sli__cont">
    <swiper-container [config]="swiperConfig" class="app-pil-sli__cont__swi" wwwSwiper init="false">
      @for (s of slides(); let i = $index; track i) {
        <swiper-slide [ngClass]="{ 'app-pil-sli__cont__swi__sl': true }" swiperSlide role="button">
          <div class="app-pil-sli__cont__swi__sl__box">
            <h2 class="app-pil-sli__cont__swi__sl__box__tit">
              {{ i === 0 ? 'ZNIŻKI U PARTNERÓW' : i === 1 ? 'KATALOG NAGRÓD' : 'INWESTYCJE' }}
            </h2>
            <img
              class="app-pil-sli__cont__swi__sl__box__img d-block d-md-none"
              [ngClass]="{ products: i === 0, awards: i === 1 }"
              [src]="s + (i !== 0 ? '-mob' : '') + '.webp'"
              [alt]="'Support slide'"
            />

            <img
              class="app-pil-sli__cont__swi__sl__box__img d-none d-md-block"
              [src]="s + '.webp'"
              [alt]="'Support slide'"
            />

            @if (i === 1) {
              <p class="app-pil-sli__cont__swi__sl__box__add">
                Wybieraj nagrodę za realizację celów. Więcej informacji u Business Partnera.
              </p>
            }
          </div>
        </swiper-slide>
      }
    </swiper-container>

    <div class="app-pil-sli__cont__swi__nav">
      <div class="app-pil-sli__cont__swi__nav--prev"></div>
      <div class="app-pil-sli__cont__swi__nav--pag"></div>
      <div class="app-pil-sli__cont__swi__nav--next"></div>
    </div>
  </div>
</section>
